module.exports = __webpack_public_path__ + "files/9f9dd26590b33d3b38760090397ef362.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/objects-3.png
// module id = 1385
// module chunks = 59